import ThemeFilter from 'components/MUIComponents/ThemeContainer/ThemeFilter';
import { LoginButton, SignInH5PWrapper, StyleCheckboxRadio } from './styled';
import MUISelectControl from 'components/Select/MUISelectControl';
import { useRef, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import {
  CircularProgress,
  IconButton,
  InputAdornment,
  TextField,
  makeStyles
} from '@material-ui/core';
import dataListSchool from './new_hcm_edu_schools.json';
import AttentionIcon from 'components/icons/AttentionIcon';
import { BlockOutlined, Visibility, VisibilityOff } from '@material-ui/icons';
import config from 'common/config';
import callApi from 'helpers/apiCaller';
import callApiNone from '../../helpers/apiCallerNone';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import _ from 'lodash';

const useStyles = makeStyles(() => ({
  autocomplete: {
    width: '100%',
    '& .MuiFormControl-root': {
      width: '100%'
    }
  },
  redIcon: {
    color: 'red'
  }
}));

const loginTypeOptions = [
  {
    label: 'Tài khoản Sở Giáo dục và Đào tạo TPHCM',
    value: 'so'
  },
  {
    label: 'Tài khoản TEST360',
    value: 'sotemp'
  }
];

function NewSignIn() {
  const classes = useStyles();
  const cookies = new Cookies();
  const checkLogin = useRef(false);
  const passwordRef = useRef(null);
  const [loginType, setLoginType] = useState('so');
  const [school, setSchool] = useState(null);
  const [loginSoTemp, setLoginSoTemp] = useState({
    username: '',
    password: '',
    eye: false
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const userStore = cookies.get('user_store');
  const siteUrl = cookies.get('SiteUrl');

  const isLoggedIn = window.localStorage.getItem('AccessToken') !== null;
  if (isLoggedIn) {
    if (!_.isEmpty(userStore)) {
      // Nếu đã đăng nhập, chuyển hướng về trang chính (hoặc trang yêu cầu)
      if (userStore?.roles != null && userStore?.roles?.student == true) {
        if (siteUrl == '' || siteUrl == undefined) {
          window.location.href = '/phong-thi-truc-tuyen';
        } else {
          window.location.href = siteUrl;
        }
      } else if (userStore?.roles != null && userStore?.roles?.school == true) {
        if (siteUrl == '' || siteUrl == undefined) {
          window.location.href = '/khoi';
        } else {
          window.location.href = siteUrl;
        }
      } else if (
        userStore?.roles != null &&
        userStore?.roles?.teacher == true
      ) {
        if (siteUrl == '' || siteUrl == undefined) {
          window.location.href = '/danh-sach-bai-thi-tu-luan';
        } else {
          window.location.href = siteUrl;
        }
      }
    } else {
      window.localStorage.removeItem('user_store');
      window.localStorage.removeItem('phone_number');
      window.localStorage.removeItem('course_id');
      window.localStorage.removeItem('register_info');

      config.DeleteDataIntoCache('user_store', '/');
      config.DeleteDataIntoCache('is_logged', '/');
      window.localStorage.removeItem('AccessToken');

      cookies.remove('user_store');
      cookies.remove('AccessToken');
      cookies.remove('access_token');
      cookies.remove('OTPStore');
      cookies.remove('showblur');
    }
  } else {
    window.localStorage.removeItem('user_store');
    window.localStorage.removeItem('phone_number');
    window.localStorage.removeItem('course_id');
    window.localStorage.removeItem('register_info');

    config.DeleteDataIntoCache('user_store', '/');
    config.DeleteDataIntoCache('is_logged', '/');
    window.localStorage.removeItem('AccessToken');

    cookies.remove('user_store');
    cookies.remove('AccessToken');
    cookies.remove('access_token');
    cookies.remove('OTPStore');
    cookies.remove('showblur');
  }

  const schoolOptions = dataListSchool.result.map((option) => ({
    value: option.MA,
    label: `${option.TEN} - ${option.TEN_XA || ''}`.trim(),
    active: option.Active
  }));

  const handleUsernameKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      passwordRef.current?.focus();
    }
  };

  //async function handleSignInSSO(event, type = 0) {
  async function handleSignInSSO(
    event,
    type = 0,
    schoolId = '',
    teacher = undefined
  ) {
    event.preventDefault();

    // let isHocSinh = false; // teacher
    // let shoolId = '';

    // if (type === 2) {
    //   shoolId = '';
    //   isHocSinh = true; // student
    // } else {
    //   shoolId = school;
    //   const schoolOption = schoolOptions.find((opt) => opt.value === school);
    //   if (schoolOption.active === 0) {
    //     swal(
    //       '',
    //       'Trường chưa được cấp quyền truy cập vào hệ thống LMS360. Quý thầy cô vui lòng liên hệ email admin@bachkhoa.tech để được hỗ trợ.',
    //       'warning',
    //       {
    //         button: 'OK'
    //       }
    //     );
    //     return;
    //   } else {
    //     setErrorMessage('');
    //   }
    // }
    var arrPGD = [
      '760',
      '761',
      '762',
      '764',
      '765',
      '766',
      '767',
      '768',
      '770',
      '771',
      '772',
      '773',
      '774',
      '775',
      '776',
      '777',
      '778',
      '783',
      '784',
      '785',
      '786',
      '787'
    ];
    var isHocSinh = true; // hs
    var isPGD = false; // true: pgd, false note pgd
    var shoolId = '';
    if (teacher != undefined) {
      if (teacher == 'teacher') {
        isHocSinh = false;
        if (schoolId == '') {
          swal('', 'Vui lòng chọn trường.', 'warning', {
            button: 'OK'
          });
          return false;
        }

        shoolId = schoolId; //event.target.shoolSSOId.value;
        if (_.includes(arrPGD, shoolId)) {
          isPGD = true;
        }
      }
    } else {
      if (type == 2) {
        shoolId = '';
      } else {
        return false;
      }
    }
    const apiBaseUrl = config.getRootURL() + '/gd/v3/hcmedu_login';
    const body = {
      school_id: shoolId,
      is_hoc_sinh: isHocSinh
    };
    setLoading(true);
    config.showLoader();
    await callApi(apiBaseUrl, 'POST', body)
      .then(function (response) {
        setLoading(false); // Mở lại nút sau khi xử lý
        config.hideLoader();
        if (response == false) {
          return false;
        }
        if (response != undefined && response.data.data.redirect_url != null) {
          if (
            window.localStorage.getItem('SiteUrl') == '' ||
            window.localStorage.getItem('SiteUrl') == undefined
          ) {
            window.location.href = response.data.data.redirect_url;
          } else {
            window.location.href = window.localStorage.getItem('SiteUrl');
          }
        } else if (response == undefined) {
          setErrorMessage('Đăng nhập không thành công.');
        }
      })
      .catch(function (error) {
        config.hideLoader();
        console.log(error);
        setLoading(false);
      });
  }

  const handleSignIn = async (event) => {
    event.preventDefault();

    let site_url = '';
    const apiBaseUrl = config.getRootURL() + '/gd/v3/login';
    const body = {
      username: loginSoTemp.username,
      password: loginSoTemp.password
    };
    config.showLoader();
    setLoading(true);
    await callApi(apiBaseUrl, 'POST', body, null, (error) => {
      setErrorMessage(error.response.data.errors[0].message);
    })
      .then(function (response) {
        config.hideLoader();
        setLoading(false);
        if (!response) {
          return false;
        }

        if (response?.data.data.user != null) {
          cookies.set(
            'user_store',
            JSON.stringify(response.data.data.user).replace(/</g, '\\u003c'),
            { path: '/' }
          );
          cookies.set('AccessToken', response.data.data.access_token, {
            path: '/'
          });
          window.localStorage.setItem(
            'AccessToken',
            response.data.data.access_token
          );

          config.AddDataIntoCache(
            'user_store',
            '/',
            JSON.stringify(response.data.data.user)
          );
          config.AddDataIntoCache('is_logged', '/', true);

          //tam off
          if (response.data.data?.user?.update_progress == 1) {
            window.location.href = '/doi-mat-khau';
            return false;
          }

          const roles = response.data.data?.user?.roles;
          if (roles.admin) {
            window.location.href = '/not-support-role';
            checkLogin.current = true;
            return;
          } else if (roles.student) {
            checkLogin.current = true;
            if (site_url == '' || site_url == null) {
              window.location.href = '/phong-thi-truc-tuyen';
            } else {
              window.location.href = site_url;
            }
          } else if (roles.school) {
            checkLogin.current = true;
            if (site_url == '' || site_url == null) {
              window.location.href = '/khoi';
            } else {
              window.location.href = site_url;
            }
          } else if (roles.teacher) {
            checkLogin.current = true;
            if (site_url == '' || site_url == null) {
              window.location.href = '/danh-sach-bai-thi-tu-luan';
            } else {
              window.location.href = site_url;
            }
          }
        } else if (response == undefined) {
          swal('', 'Đăng nhập không thành công.', 'warning', {
            button: 'OK'
          });
          return false;
        }
      })
      .catch(function (error) {
        config.hideLoader();
        console.log(error);
        setLoading(false);
        //
      });
  };

  async function getDetailSchool(event, type = 0) {
    event.preventDefault();
    if (school == null) {
      swal('', 'Vui lòng chọn trường.', 'warning', {
        button: 'OK'
      });
      return false;
    }
    const apiBaseUrl = config.getRootURL() + '/gd/v3/edu_schools/' + school;
    callApiNone(apiBaseUrl, 'GET', null, null)
      .then((response) => {
        config.hideLoader();
        if (response == false) {
          config.hideLoader();
          return false;
        }
        if (
          response.data.data != undefined &&
          response.data.data.school != undefined &&
          response.data.data.school != null
        ) {
          if (response.data.data.school.is_active == true) {
            handleSignInSSO(event, 0, school, 'teacher');
          } else if (response.data.data.school.is_active == false) {
            document.getElementById('isShowModalSuccess').click();
            return false;
          } else {
            document.getElementById('isShowModalSuccess').click();
            return false;
          }
        } else {
          document.getElementById('isShowModalSuccess').click();
          return false;
        }
      })
      .catch(function (error) {
        config.hideLoader();
        return false;
      });
  }

  return (
    <SignInH5PWrapper>
      <img
        src={`${process.env.REACT_APP_STATIC_URL}content/assets/images/image-login.png`}
        alt="Logo LMS"
        className="hidden md:block imt-20 image-login"
      />

      <div
        className="flex items-center justify-center rounded-20 shadow bg-white container-login"
        style={{ border: '1px solid #00416A' }}>
        <div className="flex flex-column items-center ip-10 lg:ip-40 w-full">
          <div>
            Một sản phẩm của
            <img
              src={`${process.env.REACT_APP_STATIC_URL}content/assets/images/logo-khong-nen---color.png`}
              alt="Logo BK"
              className="h-40 lg:h-50 iml-10"
            />
          </div>
          <a href="/">
            <img
              src={`${process.env.REACT_APP_STATIC_URL}content/assets/images/logo_hst_chu_den.png`}
              alt="Logo LMS"
              className="h-60 lg:h-70 imt-20"
            />
          </a>
          <div
            className="w-40 lg:w-70 h-1 imt-10"
            style={{ backgroundColor: '#00416A' }}></div>
          <div className="text-25 font-bold im-15">Đăng nhập</div>

          <ThemeFilter>
            <div className="w-full imt-20">
              <MUISelectControl
                options={loginTypeOptions}
                value={loginType}
                onChange={(e) => setLoginType(e.target.value)}
                displayEmpty
                shrink
              />
              {loginType === 'so' ? (
                // <form className="imt-30" onSubmit={handleSignInSSO}>
                <form className="imt-30" onSubmit={(e) => getDetailSchool(e)}>
                  <StyleCheckboxRadio className="form-radio-button">
                    <div className="form-radio-wrap radio-group">
                      <input
                        type="radio"
                        id="student"
                        name="form-radio-group"
                        defaultValue="student"
                        onClick={(e) => handleSignInSSO(e, 2)}
                      />
                      <label htmlFor="student"> Học sinh</label>
                    </div>
                    <div className="form-radio-wrap radio-group">
                      <input
                        type="radio"
                        id="teacher"
                        name="form-radio-group"
                        defaultValue="teacher"
                        defaultChecked="checked"
                        onChange={(e) => {}}
                      />
                      <label htmlFor="teacher">Giáo viên</label>
                    </div>
                  </StyleCheckboxRadio>
                  <div className="imt-30 flex items-center w-full gap-10">
                    <div
                      className="ip-10"
                      style={{
                        backgroundColor: '#00416A',
                        height: '100%',
                        borderRadius: '10px'
                      }}>
                      <img
                        src={`${process.env.REACT_APP_STATIC_URL}content/assets/images/school-icon.svg`}
                        alt="Icon School"
                      />
                    </div>
                    <div style={{ width: '100%' }}>
                      <Autocomplete
                        options={schoolOptions}
                        getOptionLabel={(option) => option.label}
                        value={
                          schoolOptions.find((opt) => opt.value === school) ||
                          null
                        }
                        onChange={(event, newValue) =>
                          setSchool(newValue ? newValue.value : '')
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Nhập tên trường"
                            variant="outlined"
                            fullWidth
                          />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.value === value.value
                        }
                        className={classes.autocomplete}
                      />
                    </div>
                  </div>
                  <div className="imt-30 iw-full text-center">
                    <LoginButton disabled={!school || loading} type="submit">
                      Đăng nhập
                    </LoginButton>
                  </div>
                  <div className="flex items-start justify-between w-full imt-30 gap-15 text-13 font-italic">
                    <AttentionIcon width={34} height={20} color="#00416A" />
                    <div>
                      Sử dụng tài khoản của Sở Giáo dục và Đào tạo TPHCM để đăng
                      nhập.{' '}
                      <a
                        href="https://lms360.vn/uploads/huong_dan.pdf"
                        target="_blank"
                        className="login-guide"
                        rel="noreferrer">
                        Xem hướng dẫn lấy tài khoản đăng nhập
                      </a>
                    </div>
                  </div>
                </form>
              ) : (
                <form className="imt-30" onSubmit={handleSignIn}>
                  <div className="flex flex-column items-center w-full gap-20">
                    <div className="flex items-center w-full gap-10">
                      <div
                        className="ip-10"
                        style={{
                          backgroundColor: '#00416A',
                          height: '100%',
                          borderRadius: '10px'
                        }}>
                        <img
                          src={`${process.env.REACT_APP_STATIC_URL}content/assets/images/username-login-icon.svg`}
                          alt="Icon School"
                        />
                      </div>
                      <TextField
                        label="Tên đăng nhập (ID)"
                        placeholder="Nhập tên đăng nhập"
                        variant="outlined"
                        fullWidth
                        value={loginSoTemp.username}
                        onChange={(e) => {
                          const value = e.target.value;
                          setLoginSoTemp((prev) => ({
                            ...prev,
                            username: value
                          }));
                        }}
                        onKeyDown={handleUsernameKeyDown}
                      />
                    </div>
                    <div className="flex items-center w-full gap-10">
                      <div
                        className="ip-10"
                        style={{
                          backgroundColor: '#00416A',
                          height: '100%',
                          borderRadius: '10px'
                        }}>
                        <img
                          src={`${process.env.REACT_APP_STATIC_URL}content/assets/images/password-login-icon.svg`}
                          alt="Icon School"
                        />
                      </div>
                      <TextField
                        label="Mật khẩu (Password)"
                        placeholder="Nhập mật khẩu"
                        variant="outlined"
                        fullWidth
                        value={loginSoTemp.password}
                        type={loginSoTemp.eye ? 'text' : 'password'}
                        onChange={(e) => {
                          const value = e.target.value;
                          setLoginSoTemp((prev) => ({
                            ...prev,
                            password: value
                          }));
                        }}
                        inputRef={passwordRef}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {loginSoTemp.eye ? (
                                <IconButton
                                  onClick={() =>
                                    setLoginSoTemp((prev) => ({
                                      ...prev,
                                      eye: false
                                    }))
                                  }>
                                  <Visibility />
                                </IconButton>
                              ) : (
                                <IconButton
                                  onClick={() =>
                                    setLoginSoTemp((prev) => ({
                                      ...prev,
                                      eye: true
                                    }))
                                  }>
                                  <VisibilityOff />
                                </IconButton>
                              )}
                            </InputAdornment>
                          )
                        }}
                      />
                    </div>
                    {errorMessage && (
                      <div className="w-full">
                        <div className="text-danger itext-14 flex items-start gap-15">
                          <BlockOutlined className={classes.redIcon} />
                          {errorMessage}
                        </div>
                      </div>
                    )}
                    <div className="imt-30 iw-full text-center">
                      <LoginButton
                        disabled={
                          !loginSoTemp.username ||
                          !loginSoTemp.password ||
                          loading
                        }
                        type="submit">
                        {loading && (
                          <CircularProgress
                            size={16}
                            style={{ color: '#fff' }}
                          />
                        )}
                        Đăng nhập
                      </LoginButton>
                    </div>
                    <div className="flex items-start justify-start w-full imt-30 gap-15 text-13 font-italic">
                      <AttentionIcon width={34} height={20} color="#00416A" />
                      <div>
                        Bạn chưa có tài khoản? <br />
                        Liên hệ ngay{' '}
                        <a href="tel:0903030246" className="login-guide">
                          090 303 0246
                        </a>{' '}
                        để được hỗ trợ.
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </ThemeFilter>
        </div>

        {/* Popup success */}
        <a
          hidden
          href="javascript:void(0);"
          id="isShowModalSuccess"
          data-toggle="modal"
          data-target={'#ShowModalSuccess'}
          className="relative"
          flow="down"></a>
        <div
          id="ShowModalSuccess"
          className="modal fade student-modal"
          tabIndex="-1"
          role="dialog"
          style={{
            background: 'linear-gradient(173deg, black, #232323a1)',
            zIndex: '99999',
            zIndex: 99999,
            overflow: 'auto',
            paddingTop: 144
          }}>
          <div
            className="modal-dialog"
            role="document"
            style={{ maxWidth: '650px' }}>
            <div className="modal-content">
              <div className="modal-header gradient-9 bg-gradient">
                <h5 className="font-bold text-light">
                  Trường chưa được cấp quyền truy cập vào hệ thống thi. Quý thầy
                  cô vui lòng liên hệ email admin@bachkhoa.tech để được hỗ trợ.
                </h5>
              </div>
              <div className="modal-body flex flex-column align-items-center ">
                <div className="ih-100 flex justify-content-center align-items-center">
                  <img
                    src={
                      process.env.REACT_APP_STATIC_URL +
                      'content/assets/images/warning-icon.png'
                    }
                    width="90"
                    height="90"
                    alt="Success .ico"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary btn-lg text-light"
                  data-dismiss="modal">
                  Đóng
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Popup success */}
      </div>
    </SignInH5PWrapper>
  );
}

export default NewSignIn;
